export default {"src":"/_next/static/media/spaceship-active.2e42b6c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};